import { createContext, useContext } from 'react';

type ILayoutDimensionsContext = {
  bottomBarV3Height: number;
  setBottomBarV3Height: (value: number) => void;
  addMoreButtonHeight: number;
  setAddMoreButtonHeight: (value: number) => void;
  toastNotificationBottom: number;
};

const LayoutDimensionsContext = createContext<ILayoutDimensionsContext>({
  bottomBarV3Height: 0,
  setBottomBarV3Height: (_value: number) => {},
  addMoreButtonHeight: 0,
  setAddMoreButtonHeight: (_value: number) => {},
  toastNotificationBottom: 0,
});

const useLayoutDimensionsContext = () => {
  return useContext(LayoutDimensionsContext);
};

export { useLayoutDimensionsContext, LayoutDimensionsContext };
